<template>
    <div>
        <div class="row">
            <div class="col-md-6 mt-2">
                <VueMultiselect
                    v-model="selectedCleaners"
                    :options="cleaners"
                    :multiple="true"
                    :close-on-select="false"
                    :clear-on-select="false"
                    :preserve-search="true"
                    :preselect-first="true"
                    :show-labels="false"
                    placeholder=""
                    label="name"
                    track-by="id"
                >
                    <template v-slot:selection="{ isOpen }"><span v-if="!isOpen">Search cleaners...</span></template>
                    <template v-slot:tag><span></span></template>
                </VueMultiselect>
            </div>
        </div>
        <div class="row">
            <div class="col-6 mt-5">
                <div class="selected-filters-container">
                    <div v-for="item in getSortedSelectedCleaner()" class="selected-filter-option">
                        {{item.name}} <a href="#" @click.prevent="unselectCleaner(item.id)"><i class="icon icon-sm icon-stroke"></i></a>
                    </div>
                </div>
            </div>
            <input
                type="hidden"
                name="managed_users"
                :value="convertToStringValue()"
            >
        </div>
    </div>
</template>

<script>
import VueMultiselect from 'vue-multiselect';

export default {
    name: "CleanerFilter",
    props: {
        initialCleaners: Array,
        excludeId: Number,
    },
    components: {
        VueMultiselect
    },
    data: function () {
        return {
            cleaners: [],
            selectedCleaners: []
        }
    },
    methods: {
        getCleaners() {
            return new Promise((resolve, reject) => {
                let url = '/api/cleaners?sort=name';
                if (this.excludeId > 0 ) {
                    url += `&excludeId=${this.excludeId}`
                }
                axios.get(url).then((res) => {
                    res.data.data.forEach(cleaner => {
                        this.cleaners.push({
                            id: cleaner.id,
                            name: cleaner.firstname + ' ' + cleaner.lastname,
                        });
                        if (this.initialCleaners && this.initialCleaners.includes(String(cleaner.id))) {
                            this.selectedCleaners.push({
                                id: cleaner.id,
                                name: cleaner.firstname + ' ' + cleaner.lastname,
                            })
                        }
                    });
                })
            });
        },
        unselectCleaner(id) {
            this.selectedCleaners = this.selectedCleaners.filter(function( obj ) {
                return obj.id !== id;
            });
        },
        convertToStringValue() {
            let value = [];
            this.selectedCleaners.forEach((item) => {
                value.push(item.id)
            })
            return value.join(',');
        },
        getSortedSelectedCleaner() {
            return this.selectedCleaners.sort((a, b) => a.name.localeCompare(b.name))
        }
    },
    mounted() {
        this.getCleaners();
    },
    created() {

    }
}
</script>

<style>
.multiselect__tags {
    padding-top: 12px;
    min-height: 48px;
    border: 1px solid #E7EAF0;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border-radius: 0px;
    box-shadow: 0px 1px 2px rgba(50, 50, 71, 0.08);
}
</style>

<style scoped>
.selected-filters-container {
    display: flex;
    align-items: flex-start;
    flex-wrap: wrap;
}
.selected-filter-option {
    border: 2px solid rgba(63, 152, 169, 0.1);
    padding: 2px 16px;
    margin: 0 6px 1.25rem 0;
}
.selected-filter-option .icon {
    margin-left: 5px;
    height: 12px !important;
    width: 10px !important;
}

.selected-filter-option .icon:hover {
    opacity: 0.6;
}
</style>
